/**
 * ขีดเดียวไร้ถ้อย (one-cut): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.7, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 11). Re-themed (user Q3 = 1, DECISIONS 2026-10-13): stillness, one cut,
 * a delayed wound — ink-slate keeps the ink flurry. The kit's cuts leave แผลเปิดช้า (`late-wound`: the wound opens when its
 * timer runs out, systems/lateWound.ts), sg-insight / sg-screen give จิตนิ่งไร้ถ้อย (slower feet, a heavier cut).
 *
 * Lock move sg-line 一 (range 2.2, the 0.35 s lock wind-up: blade raised level at eye height like a brush held over paper;
 * total stillness — the tell is the lack of motion, plus a 1-px ink bead at the tip). The shortest routine, the fastest seal
 * (catch 0.35), two blows only: the stroke `pass`es 3 m through the foe (the only fast motion; one row of 5 AI copies), the
 * caster stands back-turned in silence while the line widens, then the line opens behind it. Every blow puts on the move's
 * late-wound, so the routine's last wound opens after the foe is let go. Keys (sg* poses, paper/ink fx, a −12 dB duck, breath,
 * whisper, silence then a paper tear, the ink burst) are the contract for the motion / FX / sound lanes. Data only.
 */
import { registerLongMove } from './registry';

/** 一 ขีดเดียวพ้นภูผา — stillness, the ink gathers, one stroke through, back turned in silence, the mountain line opens. */
export const ONE_STROKE = registerLongMove({
  skillId: 'sg-line',
  kind: 'lock',
  name: 'ขีดเดียวพ้นภูผา',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 4.4,
  catch: 0.35,
  power: 2.4,
  lunge: 0.6,
  beats: [
    { at: 0, pose: 'sgStill', hits: 0, share: 0, foe: 'hit', fx: 'paperFrame', sfx: 'ambientDuck', cam: 'hold' },
    { at: 0.35, pose: 'sgInk', hits: 0, share: 0, foe: 'hit', fx: 'bladeInk', sfx: 'breathLong', cam: 'push' },
    {
      at: 1.6,
      pose: 'sgStroke',
      hits: 1,
      share: 0.2,
      foe: 'hit',
      move: { kind: 'pass', dist: 3.0 },
      ai: 5,
      fx: 'inkLine',
      sfx: 'strokeWhisper',
    },
    { at: 2.0, pose: 'sgBackTurned', hits: 0, share: 0, foe: 'hit', fx: 'inkLineWiden', sfx: 'paperTear', cam: 'hold' },
    {
      at: 2.9,
      pose: 'sgOpen',
      hits: 1,
      share: 0.8,
      foe: 'knock',
      dist: 1.4,
      stop: 0.16,
      fx: 'mountainSplash',
      sfx: 'inkBurst',
      cam: 'shake',
    },
    { at: 3.5, pose: 'sgFlick', hits: 0, share: 0, foe: 'fall', sfx: 'sheatheSoft' },
    { at: 4.0, pose: 'sgStance', hits: 0, share: 0, foe: 'recover' },
  ],
});
